import { getIframeUrl } from '@utils/strings'

export function createIframeModal(iframeId: string, src: string) {
  const theme = document
    .getElementById(iframeId)
    ?.getAttribute('data-theme')
    ?.replace('theme-', '')
  const loadingSpinner = createLoadingSpinner()
  const modal = createModal(iframeId, { theme })
  modal.addContent(loadingSpinner)

  const iframeSrc = getIframeUrl(src, iframeId, { theme })
  const iframe = document.createElement('iframe')
  iframe.id = iframeId
  iframe.src = iframeSrc
  iframe.onload = () => {
    modal.removeContent(loadingSpinner)
  }

  modal.addContent(iframe)
  return modal
}

function withQueryParam(path: string, key: string, value: string) {
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`
}

export function buildCheckoutPath(
  bookingId: string,
  options?: {
    authToken?: string | null
    prospectToken?: string | null
    embeddedWidget?: boolean
    complete?: boolean
  }
) {
  const checkoutPath = `${options?.embeddedWidget ? '/w' : ''}/o/${bookingId}${options?.complete ? '/complete' : ''}`

  if (options?.authToken) {
    return withQueryParam(checkoutPath, 'auth', options.authToken)
  }

  if (options?.prospectToken) {
    return withQueryParam(checkoutPath, 'prospect', options.prospectToken)
  }

  return checkoutPath
}

export function createModal(id: string, options?: { theme?: string | null }) {
  const modal = document.createElement('div') as HTMLDivElement
  modal.role = 'dialog'
  modal.setAttribute('aria-modal', 'true')
  modal.setAttribute('data-tl-modal-id', id)
  modal.className = 'tl-modal'
  modal.classList.add('tl-modal')
  if (options?.theme === 'dark') {
    modal.classList.add('tl-dark')
  }

  const modalPanel = document.createElement('section') as HTMLDivElement
  modalPanel.className = 'tl-modal-panel'

  const open = () => openWidgetModal(modal)

  const close = () => closeWidgetModal(modal)

  const addContent = (el: Element) => modalPanel.appendChild(el)

  const removeContent = (el: Element) => modalPanel.removeChild(el)

  const addClass = (className: string) => modalPanel.classList.add(className)

  const removeClass = (className: string) =>
    modalPanel.classList.remove(className)

  const closeButton = document.createElement('button') as HTMLButtonElement
  closeButton.className = 'tl-modal-close'
  closeButton.innerText = 'X'
  closeButton.onclick = close
  modalPanel.appendChild(closeButton)
  modal.appendChild(modalPanel)

  return { open, close, addContent, removeContent, addClass, removeClass }
}

export function openWidgetModal(modal: HTMLDivElement) {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
  document.body.appendChild(modal)
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollY}`
  document.body.style.left = '0'
  document.body.style.right = '0'
}

export function closeWidgetModal(modal: HTMLDivElement) {
  const top = document.body.style.top
  const scrollY = parseInt(top || '0') * -1
  document.documentElement.style.setProperty('--scroll-y', `${scrollY}px`)
  document.body.removeChild(modal)
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  window.scrollTo(0, scrollY)
}

export function createLoadingSpinner() {
  const loadingSpinner = document.createElement('div') as HTMLDivElement

  loadingSpinner.innerHTML = `
      <svg width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
        <path
          d='M-0.000412941 11.6077C-0.000412941 2.71598 7.97703 5.0274e-05 11.8537 0C12.5137 -8.55829e-06 13.5137 0.253906 13.5137 1.2538C13.5137 1.75391 13.0137 2.2538 11.8537 2.50982C9.00907 3.13768 2.46453 3.91707 2.46453 11.6077C2.46453 19.2983 9.08252 23.0734 12.3915 23.9996C8.26087 23.5738 -0.000412941 20.4994 -0.000412941 11.6077Z'
          fill='currentColor'
        />
      </svg>
  `

  loadingSpinner.className = 'tl-loading-spinner'
  return loadingSpinner
}
